import React from "react";

export const Input = ({ ...props }) => {
  return <input className="form-control" {...props} />;
};
